module.exports = __webpack_public_path__ + "images/183_4096.jpg";